// Costruzione del payload di un chunk di session replay per `POST …/replays`. Un
// chunk raccoglie una finestra di eventi rrweb della sessione. Contratto wire
// snake_case come gli altri builder. Gli eventi rrweb sono OPACHI qui: il masking
// PII è già applicato a monte (opzioni rrweb + `beforeSend`), questo builder non
// li ispeziona. L'`environment` è aggiunto dal client, come per le pageview.

import type { EventPayload } from './types'

/// Ingressi per un chunk di replay.
export interface ReplayChunkInput {
  /// Id di sessione opaco (vedi `session.ts`), condiviso con gli errori correlati.
  replaySessionId: string
  /// Indice progressivo del chunk nella sessione (ordina la ricostruzione).
  seq: number
  /// Epoch ms di inizio sessione (t0 relativo agli eventi rrweb).
  startedAt: number
  /// Eventi rrweb grezzi della finestra.
  events: unknown[]
  /// Pathname corrente al flush (per la galleria comportamento: pagine visitate).
  /// Omesso se non nel browser. Nessuna query string.
  path?: string | undefined
  /// Id utente (da `setUser`), se impostato: il backend lo hasha (mai in chiaro).
  user?: string | undefined
}

/// Payload di un chunk di replay per `POST …/replays`. `path`/`user` opzionali:
/// il backend è retro-compatibile coi chunk che non li portano.
export function buildReplayChunk(input: ReplayChunkInput): EventPayload {
  return {
    replay_session_id: input.replaySessionId,
    seq: input.seq,
    started_at: new Date(input.startedAt).toISOString(),
    events: input.events,
    ...(input.path ? { path: input.path } : {}),
    ...(input.user ? { user: input.user } : {}),
  }
}
